import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { Dialog } from "primereact/dialog";

import DevisDialog from "./DevisDialog/DevisDialog";

import {
  formatDateWithDaysAgo,
  invitesTemplate,
  typeTemplate,
  nameTemplate
} from "./formatTableau";

const apiUrl = process.env.REACT_APP_API_URL;

export default function ToutesFiches({ searchTerm = "" }) {
  const [loading, setLoading] = useState(true);

  const [ficheLeadsToutes, setFicheLeadsToutes] = useState([]);

  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [openSnackbarMail, setOpenSnackbarMail] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [leadToDelete, setLeadToDelete] = useState(null);

  const [ficheListeFiltreToutes, setFicheListeFiltreToutes] = useState("");

  const [devisDialogVisible, setDevisDialogVisible] = useState(false);
  const [currentLeadForDevis, setCurrentLeadForDevis] = useState(null);

  const [forceNewDevis, setForceNewDevis] = useState(false);

  const openDevisDialog = (leadData, isNew = false) => {
    setForceNewDevis(isNew);
    setCurrentLeadForDevis(leadData);
    setDevisDialogVisible(true);
  };

  const handleDevisGenerated = () => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?toutes`)
      .then((response) => {
        setFicheLeadsToutes(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du rechargement :", error);
      });
  };


  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error,
            );
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSnackbarMail = () => {
    setOpenSnackbarMail(false);
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?toutes`)
      .then((response) => {
        setFicheLeadsToutes(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const recherche = searchTerm.toLowerCase();
    const filteredList = ficheLeadsToutes.filter((fiche) => {
      const nomPrenom = fiche.nomPrenom?.toLowerCase() || "";
      const tel = fiche.tel?.toLowerCase() || "";
      const lieu = fiche.lieu?.toLowerCase() || "";
      const email = fiche.email?.toLowerCase() || "";
      return (
        nomPrenom.includes(recherche) ||
        tel.includes(recherche) ||
        lieu.includes(recherche) ||
        email.includes(recherche)
      );
    });
    setFicheListeFiltreToutes(filteredList);
  }, [searchTerm, ficheLeadsToutes]);

  const handleDeleteLead = async () => {
    if (!leadToDelete) return;

    try {
      await axios.post(`${apiUrl}IHM/api/delete_lead.php`, {
        idLead: leadToDelete.idLead,
        submissionId: leadToDelete.idSubmissions,
      });
      setDeleteDialogVisible(false);
      setLeadToDelete(null);

      window.location.reload();
    } catch (error) {
      console.error("Erreur de suppression :", error);
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbarMail}
        autoHideDuration={1000}
        onClose={handleCloseSnackbarMail}
        message={snackbarMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbarMail}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <DevisDialog
        visible={devisDialogVisible}
        onHide={() => {
          setDevisDialogVisible(false);
          setForceNewDevis(false);
        }}
        leadData={currentLeadForDevis}
        onDevisGenerated={() => {
          handleDevisGenerated();
          setForceNewDevis(false);
        }}
        forceNew={forceNewDevis}
                onResetForceNew={() => setForceNewDevis(false)}

      />
      <Dialog
        visible={deleteDialogVisible}
        header="Confirmation de suppression"
        modal
        className="custom-dialog"
        style={{ width: "30vw" }}
        onHide={() => {
          setDeleteDialogVisible(false);
          setLeadToDelete(null);
        }}
        footer={
          <div className="flex justify-content-end gap-2">
            <Button
              label="Annuler"
              icon="pi pi-times"
              severity="secondary"
              text
              onClick={() => {
                setDeleteDialogVisible(false);
                setLeadToDelete(null);
              }}
            />
            <Button
              label="Supprimer"
              icon="pi pi-trash"
              className="p-button-danger"
              onClick={handleDeleteLead}
            />
          </div>
        }
      >
        <div className="p-3">
          <p>Êtes-vous sûr de vouloir supprimer ce lead ?</p>
          <p className="text-sm text-gray-500">
            Client: <strong>{leadToDelete?.nomPrenom || ""}</strong>
          </p>
          <p className="text-sm text-gray-500">
            Cette action est irréversible.
          </p>
        </div>
      </Dialog>
      <DataTable
        value={ficheListeFiltreToutes}
        paginator
        size="small"
        rows={100}
        rowsPerPageOptions={[100, 200]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {ficheListeFiltreToutes.length}
          </span>
        }
        loading={loading}
        loadingIcon="pi pi-spin pi-spinner"
        emptyMessage={
          loading
            ? "Chargement des nouvelles fiches..."
            : "Aucune fiche pour le moment"
        }
      >
        <Column
          body={(rowData) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                icon="pi pi-trash"
                severity="danger"
                size="small"
                text
                onClick={() => {
                  setLeadToDelete(rowData);
                  setDeleteDialogVisible(true);
                }}
              />
            </div>
          )}
          style={{ width: "60px", textAlign: "center" }}
          bodyStyle={{ textAlign: "center" }}
        />

        <Column
          field="dateUpdate"
          header="Date"
          body={(rowData) => formatDateWithDaysAgo(rowData.dateUpdate)}
        />

        <Column
          field="nom"
          header="Client"
          body={(rowData) => nameTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="date"
          header="Date event"
          body={(rowData) => formatDateWithDaysAgo(rowData.dateFicheLead)}
        />

        <Column
          field="nbpers"
          header="Invités"
          body={(rowData) => invitesTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="type_bar"
          header="Type"
          body={(rowData) => typeTemplate(rowData)}
        />

        <Column
          field="etat"
          header="Statut"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            const statusColor = rowData.color || "#6b7280";

            const backgroundColor = `${statusColor}15`;

            return (
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  backgroundColor: backgroundColor,
                  color: statusColor,
                  fontSize: "13px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                  border: `1px solid ${statusColor}30`,
                }}
              >
                <span
                  style={{
                    height: "6px",
                    width: "6px",
                    borderRadius: "50%",
                    backgroundColor: statusColor,
                  }}
                ></span>

                {rowData.status}
              </div>
            );
          }}
        />

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              {rowData.a_devis == 1 && (
                <>
                  <Button
                    icon="pi pi-file-pdf"
                    severity="info"
                    text
                    raised
                    size="small"
                    tooltip="Gérer le devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, false)}
                  />
                </>
              )}
              <Button
                icon="pi pi-plus"
                severity="warning"
                text
                raised
                size="small"
                tooltip="Nouveau devis"
                tooltipOptions={{
                  position: "top",
                  style: { fontSize: "0.7rem" },
                }}
                onClick={() => openDevisDialog(rowData, true)}
              />
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
